import React from 'react'
import { Collapse } from '@material-ui/core'
import UpIcon from '@material-ui/icons/ExpandLess' 
import DownIcon from '@material-ui/icons/ExpandMore' 
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles((theme) => ({
  menuBar: {
    backgroundColor: theme.palette.details,
    boxShadow: theme.shadows[3],
    padding: '10px 16px',
    cursor: 'pointer',
    marginTop: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '16px',
  },
  titleAccordion: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '500',
    lineHeight: 'normal',
    color: theme.palette.text.primary,
  },
  subTitleAcordion: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: 'normal',
    marginTop: '5px',
    color: theme.palette.primary.main,
  },
}))

function SummaryAccordion({
  expanded,
  handleCollapse,
  title,
  subtitle,
  children,
  id,
}) {
  const classes = useStyles()
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <>
      <div className={classes.menuBar} onClick={() => handleCollapse(id)}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div className={classes.titleAccordion}>{title}</div>
          <div className={classes.subTitleAcordion}>
            {t('summary.generatedBy')}: {subtitle}
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          {expanded && expanded[id] ? (
            <UpIcon
              style={{ marginLeft: 10, color: theme.palette.primary.main }}
            />
          ) : (
            <DownIcon
              style={{ marginLeft: 10, color: theme.palette.primary.main }}
            />
          )}
        </div>
      </div>
      <Collapse in={expanded && expanded[id]} unmountOnExit>
        {children}
      </Collapse>
    </>
  )
}

export default SummaryAccordion
